import React from 'react';
import { Link } from 'react-router-dom';

export function TermsOfUse() {
  return (
    <div style={{maxWidth: 700, margin: '2rem auto', 
    borderRadius: 12, 
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)', 
    padding: '2.5rem 2rem'}}>

      <h1>Terms of Use</h1>
      <p><b>Effective Date:</b> September 19, 2025</p>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using The Personal Trainers Club, thePersonalTrainersClub.com, SweatText, or SweatText.com platform ("PTC," "SweatText," "SweatText.com," "we," "our," or "us"), you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use our services.
      </p>
      <h2>2. User Accounts</h2>
      <ul>
        <li>You must be at least 18 years old to create an account</li>
        <li>You are responsible for maintaining the confidentiality of your account credentials</li>
        <li>You agree to provide accurate and complete information when creating your account</li>
        <li>You are solely responsible for all activities that occur under your account</li>
      </ul>
      <h2>3. Trainer Accounts</h2>
      <ul>
        <li>Trainers represent that they possess appropriate qualifications and certifications</li>
        <li>PTC does not verify trainer credentials or certifications</li>
        <li>Trainers are independent contractors, not employees of PTC</li>
        <li>Trainers are responsible for the content they create and share on the platform</li>
      </ul>
      <h2>4. User-Generated Content</h2>
      <ul>
        <li>You retain ownership of content you create and share on PTC</li>
        <li>By posting content, you grant PTC a worldwide, non-exclusive license to use, reproduce, and display such content</li>
        <li>You agree not to post content that is illegal, harmful, threatening, abusive, or otherwise objectionable</li>
        <li>PTC reserves the right to remove any content that violates these terms</li>
      </ul>
      <h2>5. Subscription and Payments</h2>
      <ul>
        <li>Subscription fees are charged according to the plan you select</li>
        <li>There are no charges for this service 
          before October 1, 2025. After that date, a subscription fee of $5/month will apply to all users who joined before November 1, 2025 and remain subscribed. 
          This fee is for early adopters only and may not apply to new users joining after November 1, 2025.
        </li>
        <li>SweatText Early Adopter Pricing: Users who join and remain subscribed through November 1, 2025 
              will lock in an early adopter rate of 
              <b>$5/month</b> for the current SweatText featureset. 
        This rate applies only to features available at the time of joining; 
        new features may not be included in this rate and may require 
        additional payment. Pricing for new users or unsubscribed users
         may vary and may be higher.</li>
         <li>
          That price is only for SweatText SMS reminder services. 
         </li>
         <li>Misuse of the platform or using the platform for an excessive amount of 
          clients may result in termination of your account.
         </li>
         <li>
          Service is not guaranteed to be uninterrupted or error-free.
         </li>
        <li>Subscriptions to other tools mentioned on The Personal Trainers Club platform may have different pricing.
         </li>
        <li>If you unsubscribe or cancel your subscription, you forfeit your early adopter status and benefits, and may be charged a higher rate if you rejoin later.</li>
        <li>All payments are processed through secure third-party payment processors</li>
        <li>Subscriptions automatically renew unless canceled before the renewal date</li>
        <li>Refunds are provided in accordance with our Refund Policy</li>
      </ul>
      <h2>5a. Refund Policy</h2>
      <ul>
        <li>If you are not satisfied with your subscription, you may request a refund within 7 days of your initial payment. Refunds are not available for renewal payments or after the initial 7-day period.</li>
        <li>To request a refund, contact us at <a href="mailto:info@heldsolutionsllcs.net">info@heldsolutionsllcs.net</a> with your account details.</li>
        <li>Approved refunds will be processed to your original payment method within 10 business days.</li>
        <li>Partial refunds or exceptions may be considered at our discretion for technical issues or service disruptions.</li>
      </ul>
      <h2>6. Health and Safety Disclaimer</h2>
      <ul>
        <li>PTC is not a healthcare provider and does not offer medical advice.</li>
        <li>Consult with healthcare providers before beginning any exercise program.</li>
        <li>PTC is not responsible for injuries resulting from workouts performed using our platform.</li>
        <li>Users participate in all activities at their own risk.</li>
      </ul>
      <h2>7. Analytics and Tracking</h2>
      <ul>
        <li>We use Hotjar and Google Analytics to collect usage data</li>
        <li>These tools help us understand user behavior and improve our services</li>
        <li>You may opt out of certain tracking through your browser settings</li>
        <li>For more information, please review our Privacy Policy</li>
      </ul>
      <h2>8. Intellectual Property</h2>
      <ul>
        <li>PTC's name, logo, and platform content are protected by intellectual property laws</li>
        <li>You may not use our trademarks without prior written permission</li>
        <li>The platform and its original content are the exclusive property of PTC</li>
      </ul>
      <h2>9. Limitation of Liability</h2>
      <ul>
        <li>PTC provides the platform "as is" without warranties of any kind</li>
        <li>We are not liable for any indirect, incidental, or consequential damages</li>
        <li>Our liability is limited to the amount paid by you for subscription services</li>
        <li>We are not responsible for the actions or content of third parties</li>
      </ul>
      <h2>10. Indemnification</h2>
      <p>
        You agree to indemnify and hold PTC harmless from any claims, damages, or expenses arising from your use of the platform or violation of these terms.
      </p>
      <h2>11. Termination</h2>
      <ul>
        <li>PTC reserves the right to terminate or suspend accounts for violations of these terms</li>
        <li>You may terminate your account at any time by following the instructions on the platform</li>
        <li>Upon termination, certain provisions of these terms will survive</li>
      </ul>
      <h2>12. Governing Law</h2>
      <p>
        These terms shall be governed by the laws of the United States, without regard to its conflict of law provisions.
      </p>
      <h2>13. Changes to Terms</h2>
      <p>
        We may update these Terms of Use periodically. We will notify you of significant changes through the platform or via email.
      </p>
      <h2>14. Contact Us</h2>
      <p>
        If you have questions about these Terms of Use, please contact us at <a href="mailto:info@heldsolutionsllcs.net">info@heldsolutionsllcs.net</a>.
      </p>
      <h2>15. Client Data Protection</h2>
      <p>
        PTC is committed to protecting client data. We implement encryption, secure storage, and access controls to safeguard sensitive information. However, we cannot guarantee absolute security.
      </p>
      <h2>16. Misuse of Platform</h2>
      <ul>
        <li>Users agree not to misuse the platform, including attempting unauthorized access or disrupting services.</li>
        <li>PTC reserves the right to suspend or terminate accounts involved in misuse.</li>
      </ul>
      <h2>17. Severability</h2>
      <p>
        If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.
      </p>
      <h2>18. Security Measures</h2>
      <ul>
        <li>PTC employs industry-standard security measures to protect user data.</li>
        <li>Users are responsible for maintaining the security of their account credentials.</li>
      </ul>
      <h2>19. Medical Advice Disclaimer</h2>
      <ul>
        <li>PTC is not a healthcare provider and does not offer medical advice.</li>
        <li>Any medical advice provided by trainers on the platform is their sole responsibility.</li>
        <li>PTC does not verify the medical qualifications of trainers and is not liable for any harm resulting from their advice.</li>
        <li>Users should consult licensed healthcare professionals for medical concerns.</li>
      </ul>
      <h2>20. Trainer Qualifications</h2>
      <ul>
        <li>Trainers are responsible for accurately representing their qualifications and certifications.</li>
        <li>PTC does not verify trainer credentials and is not liable for misrepresentations.</li>
        <li>Users are encouraged to independently verify trainer qualifications before acting on their advice.</li>
      </ul>
      <h2>21. Demo Tools Disclaimer</h2>
      <p>
        Many tools provided on the platform are conceptual demos and are not intended for actual use with clients or workouts. Users should not rely on these tools for professional fitness advice or programming.
      </p>
      <h2>22. Injury and Advice Disclaimer</h2>
      <p>
        PTC is not responsible for injuries or harm resulting from the use of demo tools or workout information provided on the platform. Users should consult certified professionals for fitness advice and exercise programming.
      </p>
      <h2>23. Professional Certification Disclaimer</h2>
      <p>
        Workout information and advice provided on the platform are not certified by licensed professionals unless explicitly stated. Users should independently verify the qualifications of trainers and consult healthcare providers for medical concerns.
      </p>
    </div>
  );
}